'use client'

import DisablePrefetchLink from '@component/disablePrefetchLink'
import { HOUSE_TYPE_ID } from '@config'
import getHouseRoute from '@plugin/searchRoute/modules/house'
import { houseList } from '@router'
import { houseSearchType } from '@routerConfig'
import { getSlug } from '@utils'
import classNames from 'classnames'
import { cond, constant, get, map } from 'lodash-es'
import { useBoolean } from 'react-use'

export default function SeoFilterContent({
  data
}) {

  const [viewAll, toggleAll] = useBoolean(false)
  return (
    <div className='flex gap-x-140 flex-col gap-y-40 md:flex-row'>
      {
        map(data, (item, idx) => (
          <Column data={item} key={idx} viewAll={viewAll} toggleAll={toggleAll}></Column>
        ))
      }
    </div>
  )
}

function Column({
  data,
  viewAll,
  toggleAll
}) {

  return (
    <div>
      <div className='text-xl'>{data.title}</div>
      <div className='space-y-16 mt-16'>
        {
          map(data.data, (item, idx) => (
            <div key={idx} className={classNames({'hidden': !viewAll && idx >= 3})}>
              <DisablePrefetchLink href={getRoute(item)} target='_blank' className='button-text-primary' key={idx}>{item.name} ({item.num})</DisablePrefetchLink>
            </div>
          ))
        }
        {
          !viewAll && (
            <button className='button-text-primary text-base' onClick={() => toggleAll()}>See all</button>
          )
        }
      </div>
    </div>
  )
}

function getRoute(data) {
  const label = get(data, 'label')
  const { regionId, districtId, suburbId, categoryId, categoryName, typeId } = get(data, 'query', {})

  const houseRoute = getHouseRoute()
  if (regionId) {
    houseRoute.setSuburbs({ label: label, id: regionId, level: 'region' })
  }
  if (districtId) {
    houseRoute.setSuburbs({ label: label, id: districtId, level: 'district' })
  }
  if (suburbId) {
    houseRoute.setSuburbs({ label: label, id: suburbId, level: 'suburb' })
  }

  houseRoute.pushNewZealand()

  if (categoryId) {
    const slug = categoryName ? getSlug(categoryName, categoryId) : getSlug(categoryId)
    if (
      [
        HOUSE_TYPE_ID['commercial-property-for-sale'],
        HOUSE_TYPE_ID['commercial-property-for-lease'],
        HOUSE_TYPE_ID['businesses-for-sale'],
      ].includes(typeId)
    ) {
      houseRoute.categories.push(slug)
    } else {
      houseRoute['property-type'].push(slug)
    }
  }

  const searchType = cond([
    [constant(HOUSE_TYPE_ID.residential === typeId), constant(houseSearchType.residential)],
    [constant(HOUSE_TYPE_ID.rent === typeId), constant(houseSearchType.rent)],
    [constant(HOUSE_TYPE_ID.sold === typeId), constant(houseSearchType.sold)],
    [constant(HOUSE_TYPE_ID.rural === typeId), constant(houseSearchType.rural)],
    [constant(HOUSE_TYPE_ID['commercial-property-for-sale'] === typeId), constant(houseSearchType.commercialForSale)],
    [constant(HOUSE_TYPE_ID['commercial-property-for-lease'] === typeId), constant(houseSearchType.commercialForLease)],
    [constant(HOUSE_TYPE_ID['businesses-for-sale'] === typeId), constant(houseSearchType.business)],
    [constant(HOUSE_TYPE_ID['new-homes'] === typeId), constant(houseSearchType.newHomes)],
  ])()

  return houseList(searchType, houseRoute.toSlug())
}